export default "__VITE_ASSET__CwMqTGjB__"